import { render, staticRenderFns } from "./NF1ModalBlock2.vue?vue&type=template&id=fd8fcfb6&scoped=true"
import script from "./NF1ModalBlock2.vue?vue&type=script&lang=js"
export * from "./NF1ModalBlock2.vue?vue&type=script&lang=js"
import style0 from "./NF1ModalBlock2.vue?vue&type=style&index=0&id=fd8fcfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8fcfb6",
  null
  
)

export default component.exports